import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef} from '@angular/material';

// Imports Application
import { DContextoMuisca, DLogger } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DBasicosParametricasServicios, DParametrosPolitica } from '@dian/api-basicos-parametricas';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DObserverTimerSessionApp } from './configuracion/dformulario-configuracion';
import { InfoComponent } from './modal/modals/info/info.component';
import { SuccessComponent } from './modal/modals/success/success.component';
import { WarningComponent } from './modal/modals/warning/warning.component';
import { ModalService, ModalType } from './modal/services/modal.service';
import { GeneralService } from './services/general.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DDevolucionesServicios } from '@dian-api/devoluciones';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    DContextoUsuarioServicio,
    DNotificacionServicio,
    DBasicosParametricasServicios,
    DDevolucionesServicios
    
  ]
})
export class AppComponent implements OnInit{
  	
    public rutaSelector: string;
  	private datosRespuesta:DContextoMuisca;    
    private nombreUsuario:string;
    private nombreOrganizacion:string;
    private precargaCabecera:boolean = true;
    private tiempo:Date;  
    @ViewChild(InfoComponent) infoComponent : InfoComponent;
    @ViewChild(SuccessComponent) successComponent : SuccessComponent;
    @ViewChild(WarningComponent) warningComponent : WarningComponent;

    /**
    * @constructor
    */
    constructor(
        private dialog: MatDialog,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private dNotificacionServicio:DNotificacionServicio,
        private dBasicosParametricasServicios:DBasicosParametricasServicios,
        private dlogger:DLogger,
        private modalService : ModalService,
        private generalService: GeneralService
    ) {            
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
        observableServicio.subscribe(
            res => {
                this.precargaCabecera = false;
                this.datosRespuesta = <DContextoMuisca>res; 
                this.generalService.setDatosUsuario(this.datosRespuesta);
                this.tiempo = new Date();               
                let tiempoReal = new Date();    
                this.verificarSession();                        

                setInterval(()=>{
                    tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
                    this.tiempo = new Date(tiempoReal);                    
                }, 1000);
            }
        );

        this.obtenerRutaSelector();
    }  

    ngOnInit(): void {
        this.initModals();
    }

    initModals() {
        this.successComponent.hide();
        this.warningComponent.hide();
        this.infoComponent.hide();
        this.modalService.onShow(ModalType.INFO, body => {
            this.infoComponent.show(body);
        })
        this.modalService.onHide(ModalType.INFO, () => {
            this.infoComponent.hide();
        })
        this.modalService.onShow(ModalType.SUCESS, body => {
            this.successComponent.show(body);
        })
        this.modalService.onHide(ModalType.SUCESS, () => {
            this.successComponent.hide();
        })
        this.modalService.onShow(ModalType.WARNING, body => {
            this.warningComponent.show(body);
        })
        this.modalService.onHide(ModalType.WARNING, () => {
            this.warningComponent.hide();
        })
    }

    /**
    * @desc Función para enviar un log
    */
    public enviarLog() {
        let dialogo = {
            height: '450px',
            disableClose: true
        };     
        let dialogRef = this.dialog.open(DEnvioLogComponente, dialogo);
        dialogRef.afterClosed().subscribe(result => {
            console.log('Dialog result: ', result);
        });    
    }

    /**
    * @desc Función para redireccionar a un link especifico de Muisca
    */
    public hrefButton (href:string) {
        window.location.href = location.origin + href;
    }

    /**
    * @desc Función para abrir un link especifico de Muisca en otra pestaña
    */
    public hrefButtonOpen(href:string){
        window.open(location.origin + href);
    }

    /**
    * @desc Función para hacer el logout de la aplicación
    */
    public logoutApp() {
        this.dContextoUsuarioServicio.logOut();
    }

    /**
    * @desc Funcion que verifica un observable para validar la session
    */
    private verificarSession() {
        let observer:DObserverTimerSessionApp = new DObserverTimerSessionApp(this.dNotificacionServicio, this.dContextoUsuarioServicio);
        let ObservableTimer = this.dContextoUsuarioServicio.establecerAccionCierreSesionUsuario(observer);
        ObservableTimer.subscribe(
            respuesta  => {
                this.dlogger.info('Accion establecida con cerrar sesión', respuesta);            
            },              
            error =>{  
                this.dlogger.error('Error estableciendo accion de cierre de sesión', error);
            });
    }

    private obtenerRutaSelector() {
        //this.rutaSelector = '/WebDilGestorFormularios';
        this.dBasicosParametricasServicios.obtenerPolitica(318,"DILIGENCIAMIENTO").subscribe(
            res=>{
                let parametroPolitica = <DParametrosPolitica>res;
                this.rutaSelector = parametroPolitica.parametros[0].valor;
                this.dlogger.info('Accion establecida con obtener ruta selector', res); 
            },error=>{
                this.dlogger.error('Error obteniendo ruta del selector', error);
            }
        );
    }       

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/app.component.ts